import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PHOTO_URLS_FETCHED } from '../actions/actionTypes';
import './Photos.css';
import { fetchPhotoUrls } from '../actions/photos';

const mapStateToProps = state => ({
  photoUrls: state.photos.urls,
});

const mapDispatchToProps = dispatch => ({
  photoUrlsFetched: payload => dispatch({ type: PHOTO_URLS_FETCHED, payload }),
});

function importAll(r) {
  const images = {};
  r.keys().forEach(item => {
    images[item.replace('./', '')] = r(item);
  });
  return images;
}

const images = importAll(require.context('../assets/gallery', false, /\.jpg$/));

const PhotoViewer = ({ img, func }) => (
  <div className="photo-viewer" onClick={func}>
    <div className="photo-viewer-photo">
      <img src={img} alt="big pic of us having fun" />
    </div>
  </div>
);

const Photo = ({ img, func }) => (
  <div className="photo" onClick={() => func(img)}>
    <img src={img} alt="another pic of us having fun" />
  </div>
);

const StaticPhotos = ({ func }) =>
  Object.entries(images).map(([imageName, imagePath]) => (
    <Photo img={imagePath} key={imageName} func={func} />
  ));

const InstagramPhotos = ({ urls = [], func }) => {
  return Object.entries(urls).map(([index, url]) => (
    <Photo img={url} key={index} func={func} />
  ));
};

class Photos extends Component {
  async componentWillMount() {
    this.sectionId = `section-${this.props.section}`;

    this.getPhotos();

    this.setState({
      selectedPhoto: null,
    });
  }

  async getPhotos() {
    const urls = await fetchPhotoUrls();
    this.props.photoUrlsFetched(urls);
  }

  showPhoto(img) {
    this.setState({
      selectedPhoto: img,
    });
  }

  hidePhoto() {
    this.setState({
      selectedPhoto: null,
    });
  }

  render() {
    return (
      <section id={this.sectionId}>
        <h1>Photos</h1>
        <div className="photos-area">
          <InstagramPhotos
            urls={this.props.photoUrls}
            func={this.showPhoto.bind(this)}
          />
          <StaticPhotos func={this.showPhoto.bind(this)} />
        </div>
        {this.state.selectedPhoto ? (
          <PhotoViewer
            img={this.state.selectedPhoto}
            func={this.hidePhoto.bind(this)}
          />
        ) : (
          ''
        )}
      </section>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Photos);



// WEBPACK FOOTER //
// ./src/components/Photos.js